var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import FeatureRolloutLogPerformanceConstants from "../actions/FeatureRolloutLogPerformanceConstants.js";
const getDefaultState = () => {
  return {
    pageLoadClientTime: null,
    overviewMainFunctionalityClientTime: null,
    progressionsMainFunctionalityClientTime: null,
    mainFunctionality: null,
    overviewFullLoadClientTime: null,
    progressionsFullLoadClientTime: null,
    progressionsScorecardFullLoadClientTime: null,
    alertsFullLoadClientTime: null,
    fullLoad: null
  };
};
const loadStart = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    pageLoadClientTime: actionResult.payload.clientTimeInMs,
    overviewMainFunctionalityClientTime: null,
    progressionsMainFunctionalityClientTime: null,
    mainFunctionality: null,
    overviewFullLoadClientTime: null,
    progressionsFullLoadClientTime: null,
    progressionsScorecardFullLoadClientTime: null,
    alertsFullLoadClientTime: null,
    fullLoad: null
  });
};
const mainFunctionality = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    mainFunctionality: {
      timeSinceLoadStartInMs: actionResult.payload.timeSinceLoadStartInMs,
      lastPartToLoad: actionResult.payload.lastPartToLoad
    }
  });
};
const fullLoad = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    fullLoad: {
      timeSinceLoadStartInMs: actionResult.payload.timeSinceLoadStartInMs,
      lastPartToLoad: actionResult.payload.lastPartToLoad
    }
  });
};
const FeatureRolloutLogPerformanceReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case FeatureRolloutLogPerformanceConstants.LOAD_START:
      return loadStart(state, actionResult);
    case FeatureRolloutLogPerformanceConstants.SET_OVERVIEW_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        overviewMainFunctionalityClientTime: actionResult.payload.clientTimeInMs
      });
    case FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        progressionsMainFunctionalityClientTime: actionResult.payload.clientTimeInMs
      });
    case FeatureRolloutLogPerformanceConstants.MAIN_FUNCTIONALITY:
      return mainFunctionality(state, actionResult);
    case FeatureRolloutLogPerformanceConstants.SET_OVERVIEW_FULL_LOAD:
      return __spreadProps(__spreadValues({}, state), {
        overviewFullLoadClientTime: actionResult.payload.clientTimeInMs
      });
    case FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_FULL_LOAD:
      return __spreadProps(__spreadValues({}, state), {
        progressionsFullLoadClientTime: actionResult.payload.clientTimeInMs
      });
    case FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_SCORECARDS_FULL_LOAD:
      return __spreadProps(__spreadValues({}, state), {
        progressionsScorecardFullLoadClientTime: actionResult.payload.clientTimeInMs
      });
    case FeatureRolloutLogPerformanceConstants.SET_ALERTS_FULL_LOAD:
      return __spreadProps(__spreadValues({}, state), {
        alertsFullLoadClientTime: actionResult.payload.clientTimeInMs
      });
    case FeatureRolloutLogPerformanceConstants.FULL_LOAD:
      return fullLoad(state, actionResult);
    default:
      return state;
  }
};
export {
  FeatureRolloutLogPerformanceReducer,
  FeatureRolloutLogPerformanceReducer as default,
  getDefaultState
};
//# sourceMappingURL=FeatureRolloutLogPerformanceReducer.js.map
